import styled from "styled-components";
import { SyncOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { IMG_TOP_BG, IMG_BADGE } from "@assets";

export const RootContainer = styled.div`
  position: relative;
  height: 100vh;
  overflow-y: auto;
`;

export const RefreshIcon = styled(SyncOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const TableWrapper = styled.div`
  margin-top: 365px;
  padding-bottom: 20px;

  .ant-table-wrapper {
    margin: 16px 16px 0 16px;
  }

  @media screen and (max-width: 400px) {
    margin-top: 340px;
  }
  @media screen and (max-width: 365px) {
    .ant-table-cell {
      font-size: 12px !important;
    }
  }
  @media screen and (max-width: 330px) {
    .ant-table-cell {
      padding: 8px 1px !important;
    }
  }
`;

export const Bottom = styled(Space)`
  padding-top: 305px;
  padding-bottom: 16px;
  z-index: 99;
  background-color: ${(props) => props.theme.backgroundColor};
  position: fixed;
  width: 100%;
  max-width: 480px;
  gap: 16px !important;
  justify-content: center;

  .ant-space-item {
    flex: 1;

    :nth-child(1) {
      text-align: right;
      padding-inline-start: 16px;
    }

    :nth-child(2) {
      text-align: left;
      padding-inline-end: 16px;
    }
  }

  .ant-btn {
    width: 100%;
    background-color: #71207c !important;
  }

  @media screen and (max-width: 400px) {
    padding-top: 285px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  text-align: center;
`;

export const TopBgImage = styled.img.attrs({
  alt: "bg-img",
  src: IMG_TOP_BG,
})`
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 480px;
  height: 250px;
  z-index: 500;

  @media screen and (min-width: 400px) {
    height: 300px;
  }
`;

export const SpinnerBox = styled.div`
  width: 100%;
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const WheelContainer = styled.div`
  position: fixed;
  width: 100%;
  max-width: 480px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;

  > div {
    width: 245px;
    height: 245px;
  }

  img:not(#badge-img) {
    top: calc(50% - 51px);
    left: calc(50% + 38px);
    width: 100px !important;

    transform: rotate(-37deg) translate(-50%, -50%); /* W3C */
    -webkit-transform: rotate(-37deg) translate(-50%, -50%); /* Safari & Chrome */
    -moz-transform: rotate(-37deg) translate(-50%, -50%); /* Firefox */
    -ms-transform: rotate(-37deg) translate(-50%, -50%); /* Internet Explorer */
    -o-transform: rotate(-37deg) translate(-50%, -50%); /* Opera */
  }

  @media screen and (max-width: 400px) {
    > div {
      width: 230px;
      height: 230px;
    }
  }

  @media screen and (max-width: 325px) {
    margin-top: 45px;
    
    > div {
      width: 200px;
      height: 200px;
    }

    img:not(#badge-img) {
      top: calc(50% - 48px);
      left: calc(50% + 35px);
      width: 90px !important;

      transform: rotate(-37deg) translate(-50%, -50%); /* W3C */
      -webkit-transform: rotate(-37deg) translate(-50%, -50%); /* Safari & Chrome */
      -moz-transform: rotate(-37deg) translate(-50%, -50%); /* Firefox */
      -ms-transform: rotate(-37deg) translate(-50%, -50%); /* Internet Explorer */
      -o-transform: rotate(-37deg) translate(-50%, -50%); /* Opera */
    }
  }
`;

export const OuterBadge = styled.img.attrs({
  alt: "badge",
  id: "badge-img",
  src: IMG_BADGE,
})`
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  cursor: pointer;

  @media screen and (max-width: 400px) {
    width: 260px;
    height: 260px;
  }

  @media screen and (max-width: 325px) {
    width: 230px;
    height: 230px;
  }
`;

export const Container = styled.div`
  position: relative;
  z-index: 999;
  text-align: center;
  padding-top: 80px;

  .ant-btn {
    min-width: 80px;
    margin-top: 120px;
  }
`;

export const Text = styled.div`
  padding-bottom: 10px;
  color: #fff;
  font-size: 18px;
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
